export const MenuImages = {
  userIcon: require('./user.svg'),
  helpIcon: require('./help.svg'),
  logout: require('./logout.svg'),
  profile: require('./profile.svg'),
  checkIcon: require('./check.svg'),
  create: require('./create.svg'),
  manage: require('./folder.svg'),
  activeBackground: require('./activeBackground.png'),
  lockedBackground: require('./lockedBackground.png'),
  settings: require('./settings.svg'),
  mobileMenuBackground: require('./mobileMenuBackground.svg'),
};
